exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-editor .ql-editor p {\n  margin: 0 0 10px; }\n\n.ql-editor {\n  max-height: 500px;\n  overflow-y: auto; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/utils/SimpleTextEditor/SimpleTextEditor.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,iBAAiB,EAAE","file":"SimpleTextEditor.scss","sourcesContent":[".my-editor .ql-editor p {\n  margin: 0 0 10px; }\n\n.ql-editor {\n  max-height: 500px;\n  overflow-y: auto; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/utils/SimpleTextEditor/SimpleTextEditor.scss
// module id = 1177
// module chunks = 0